/**
 * Resolves whether a review thread's composer should treat the thread as
 * locked, across the three signals that can carry that information:
 *
 *   1. `responseLocked` — `GetMessagesResponse.locked` from the
 *      thread-messages fetch, the BE's authoritative answer once that query
 *      has loaded (entry status for selection threads, review-approved for
 *      script/content threads). `undefined` means the fetch hasn't landed
 *      yet (or predates the field) — NOT "unlocked" — so it falls through
 *      to the row hint rather than forcing false.
 *   2. `rowLocked` — the roster row's own `*_thread_locked` field (or
 *      status-derived equivalent), a fetch-time hint available before the
 *      thread-messages query resolves.
 *   3. `liveLocked` — the local 423-on-send override (see
 *      isThreadLockedError in notificationErrors.ts): a same-session lock
 *      that happened after the panel opened, before either of the above
 *      have refetched. Always wins when true — it is a backstop, not
 *      superseded by a stale `false` from either other source.
 */
export function resolveThreadLocked(
  responseLocked: boolean | undefined,
  rowLocked: boolean,
  liveLocked: boolean,
): boolean {
  return (responseLocked ?? rowLocked) || liveLocked;
}
